import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { projectDataClient } from '../../../lib/connect/clients';
import { useTenantId } from '../../Delivery/_shared/hooks/useTenantId';
import { invalidatePursuitReads } from './pursuitQueryKeys';
const RFP_EXPECTED_KEY = 'opportunity-rfp-expected';
/**
 * GRW-06: the opportunity's stored RFP-expected value, with the version the
 * dialog sends back as `expectedVersion` (read from GetOpportunityContext).
 */ export function useOpportunityRfpExpected(opportunityId, enabled) {
    const tenantId = useTenantId();
    return useQuery({
        queryKey: [
            RFP_EXPECTED_KEY,
            tenantId,
            opportunityId
        ],
        queryFn: async ()=>(await projectDataClient.getOpportunityContext({
                opportunityId
            })).rfpExpected ?? null,
        enabled: enabled && !!opportunityId,
        retry: false,
        gcTime: 0
    });
}
/**
 * GRW-06: set or clear the RFP-expected date. A stale version comes back as
 * Aborted with no change. Success refetches the header (the rail fact).
 */ export function useSetOpportunityRfpExpected() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (args)=>projectDataClient.setOpportunityRfpExpected(args),
        // Refetch the stored value either way: after a conflict it carries the new version.
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: [
                    RFP_EXPECTED_KEY
                ]
            }),
        onSuccess: ()=>invalidatePursuitReads(queryClient)
    });
}
